<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field required name="type" label="证书类型" input-align="right">
        <template #input>
          <van-radio-group v-model="form.type" @change="changeType">
            <van-radio name="1" checked-color="#FF5733">活动证书</van-radio>
            <van-radio name="2" checked-color="#FF5733">捐赠证书</van-radio>
            <van-radio name="3" checked-color="#FF5733">培训证书</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field required readonly clickable name="picker" :value="form.deptName" label="选择队伍"
                 placeholder="请选择队伍"
                 @click="showDept = true" input-align="right"/>
      <van-popup v-model="showDept" position="bottom">
        <van-picker show-toolbar :columns="deptList" @confirm="onConfirmDept" @cancel="showDept = false"/>
      </van-popup>

      <van-field required readonly clickable name="picker" :value="form.projectName" label="选择项目"
                 placeholder="请选择项目"
                 @click="showProject = true" input-align="right"/>
      <van-popup v-model="showProject" position="bottom">
        <van-picker show-toolbar :columns="projectList" @confirm="onConfirmProject" @cancel="showProject = false"/>
      </van-popup>

    </van-form>


    <van-goods-action style="margin-bottom: 20px">
      <van-goods-action-button type="danger" color="#FF5733" text="确认提交" @click="submitForm"
                               :loading="buttonLoading" :disabled="buttonLoading"/>

    </van-goods-action>

  </div>
</template>

<script>
import {getDeptList, getProjectList} from "@/api";
import {addUserCertificate} from "@/api/certificate";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: "ApplyCertificate",
  data() {
    return {
      buttonLoading: false,
      showProject: false,
      showDept: false,
      form: {
        type: '1',
        deptName: '',
        projectName: '',
      },
      projectList: [],
      deptList: []
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading()
    // 获取证书项目列表
    getProjectList(1).then(res => {
      if (res.data) {
        this.projectList = res.data.map(item => {
          return item.projectName
        })
      }
      // 获取团队信息
      return getDeptList()
    }).then(res => {
      if (res.data) {
        this.deptList = res.data.map(item => {
          return item.deptName
        })
      }
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    /**
     * 提交表单
     */
    submitForm() {
      if (!this.form.type) {
        this.$modal.alert("请选择证书类型")
        return
      }
      if (!this.form.deptName) {
        this.$modal.alert("请选择队伍")
        return
      }
      if (!this.form.projectName) {
        this.$modal.alert("请选择项目")
        return
      }

      this.buttonLoading = true
      this.$modal.loading("正在提交")
      addUserCertificate(this.form).then(res => {
        this.$modal.success("保存成功")
        this.$router.push({
          path: '/mine'
        });
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    changeType(name) {
      this.$modal.loading()
      this.form.projectName = ''
      this.projectList = []
      getProjectList(name).then(res => {
        if (res.data) {
          this.projectList = res.data.map(item => {
            return item.projectName
          })
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    /**
     * 提交团队选择
     */
    onConfirmDept(value) {
      this.form.deptName = value
      this.showDept = false
    },
    /**
     * 提交项目
     */
    onConfirmProject(value) {
      this.form.projectName = value
      this.showProject = false
    }
  }
}
</script>

<style scoped>
>>> .van-radio__label {
  line-height: 8.333333vw;
}
</style>
